module.exports = __webpack_public_path__ + "img/faq51.d274b05c.png";